import Link from "next/link";
import { abrirPreferenciasCookies } from "@/lib/consentimento";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import Logomarca from "./Logomarca";

interface props {
    marginBotton?: number
}

const URL_SAFE_BROWSING = 'https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Fwww.agenciamixshows.com.br%2F'

export default function FooterHome({marginBotton}: props) {

    const redeSocialItem = (icone: any, link: string, nome: string) => {

        const abreLink = () => {
            if (link != '') {
                window.open(link, '_blank')
            }
        }

        return (
            <button type="button" aria-label={nome} className="rounded-xl bg-gray-900 p-3 cursor-pointer" onClick={() => abreLink()}>
                {icone}
            </button>
        )
    }

    const tituloColuna = (titulo: string) => (
        <p className="text-lg font-semibold mb-4">{titulo}</p>
    )

    const classeLink = "block hover:underline"

    return (
        <footer style={{marginBottom: marginBotton ? marginBotton : 0}}>
            <div className="bg-gray-800 p-3 flex justify-center gap-5 text-white">
                {redeSocialItem(<FaInstagram size={26} />, 'https://instagram.com/agenciamix', 'Instagram')}
                {redeSocialItem(<FaFacebook size={26} />, '', 'Facebook')}
                {redeSocialItem(<FaYoutube size={26} />, '', 'YouTube')}
                {redeSocialItem(<FaTwitter size={26} />, '', 'X')}
            </div>
            <div className="bg-gray-900 text-white px-5 md:px-10 py-12 text-sm">
                <div className="container mx-auto grid grid-cols-2 lg:grid-cols-4 gap-10">
                    <div className="col-span-2 lg:col-span-1 flex justify-center lg:justify-start">
                        <div style={{ width: '160px' }}>
                            <Logomarca tipo="quebrado" color="branca" size="100%" />
                        </div>
                    </div>
                    <div>
                        {tituloColuna('Minha Conta')}
                        <div className="space-y-3">
                            <Link className={classeLink} href="/dashboard/pedidos">Meus Ingressos</Link>
                            <Link className={classeLink} href="/dashboard/perfil">Meu Perfil</Link>
                            <Link className={classeLink} href="/dashboard/perfil/senha">Alterar Senha</Link>
                        </div>
                    </div>
                    <div>
                        {tituloColuna('Políticas')}
                        <div className="space-y-3">
                            <Link className={classeLink} href="/auth/politica" target="_blank">Privacidade</Link>
                            <Link className={classeLink} href="/auth/regras-meia-entrada" target="_blank">Meia Entrada</Link>
                            <Link className={classeLink} href="/auth/termos" target="_blank">Termos de Uso</Link>
                            <button type="button" className={`${classeLink} text-left`} onClick={abrirPreferenciasCookies}>Preferências de cookies</button>
                        </div>
                    </div>
                    <div className="col-span-2 lg:col-span-1 space-y-6">
                        <a href={URL_SAFE_BROWSING} target="_blank" rel="noreferrer" className="inline-block" aria-label="Ver o relatório do Google Safe Browsing deste site">
                            <img src="/images/siteseguro.svg" alt="Site seguro" style={{ width: '200px' }} />
                        </a>
                        <div>
                            <p className="font-semibold mb-2">Métodos de pagamento</p>
                            <p className="text-xs mb-3">Pagamentos em até 10 vezes no cartão</p>
                            <img src="/images/metodos_pagamento.png" alt="Bandeiras aceitas" />
                        </div>
                    </div>
                </div>
                <div className="container mx-auto mt-12 flex items-center justify-center gap-3 text-center text-xs">
                    <img className="bandeira-rodape" src="/images/informacao.png" alt="" />
                    <p>Todos os preços e condições comerciais estão sujeitos a alteração comercial sem prévio aviso.</p>
                </div>
            </div>
            <div className="text-center text-gray-900 p-4" style={{ fontSize: '11px' }}>
                © <strong>Agência Mix</strong> {new Date().getFullYear()} - Todos os direitos reservados - www.agenciamixshows.com.br
            </div>
        </footer>
    )
}
